'use strict'

// import { CookiePolicy } from './lib/CookiePolicy'
import { Svg } from './lib/Svg'
import { TelGrant } from './lib/TelGrant'
import { Smooth } from './lib/Smooth'
import { Drawer } from './lib/Drawer'
import { ScrollStatus } from './lib/ScrollStatus'
import { ScrollAnimation } from './lib/ScrollAnimation'
import { Accordion } from './lib/Accordion'
import { ReportSlider } from './lib/ReportSlider'
import { TextSplit } from './lib/TextSplit'
import { FacilitySlider } from './lib/FacilitySlider'
import { FacilityFixed } from './lib/FacilityFixed'
import { Opening } from './lib/Opening'
import { IntroSlider } from './lib/IntroSlider'
// new CookiePolicy('optout')

new Svg()
new TelGrant()
new Smooth()
new Drawer()
new ScrollStatus()
new ScrollAnimation()
new Accordion()
new ReportSlider()
new TextSplit()
new FacilitySlider()
new FacilityFixed()
new Opening()
new IntroSlider()
